<template>
  <v-app class="centered-card">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
            md="4"
            lg="6"
          >
            <slot name="before-logo" />
            <img
              alt="Setra CEMS Diligence Logo"
              src="/storage/diligence-logo-login.svg"
              width="300"
              height="53"
              id="logo"
              class="mb-12 mx-auto d-flex"
              crossorigin="anonymous"
            >
            <slot name="before-card" />
            <v-card
              class="mb-4"
            >
              <slot />
            </v-card>
            <div class="text-center">
              <slot name="after-card" />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'CenteredCard',
};
</script>

<style scoped>
.v-application {
    font-family: 'Titillium Web', 'Roboto', sans-serif;
}
.centered-card {
    background: #fbfbfb;
}
#logo {
  max-width: 300px;
  height: auto;
}
</style>
